import { id } from 'date-fns/locale';
import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getContainerQrcodes($limit: Int, $offset: Int, $order: String, $where: String) {
    getContainerQrcodes(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        qrCode
        collectionPointId
        binSerialNo
        latitude
        longitude
        declaredByUser
        declaredDate
        comments
        driverComments
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
        collectionpoint {
          id
          name
          code
          addressLine1
          addressArea
          addressCity
          addressDistrict
        }
        containerTypeId
        containertype {
          id
          name
        }
        photoFileId1
        photo1 {
          id
          fileName
          mimeMediaType
          s3Key
        }
        photoFileId2
        photo2 {
          id
          fileName
          mimeMediaType
          s3Key
        }
      }
      recordCount
    }
  }
`;

// Get one QR code by id
export const gqlGetByIdQuery = gql`
  query getContainerQrcodeById($id: Int!) {
    getContainerQrcodeById(id: $id) {
      id
      qrCode
      collectionPointId
      binSerialNo
      containerTypeId
      latitude
      longitude
      declaredByUser
      declaredDate
      comments
      driverComments
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      collectionpoint {
        id
        name
        code
        addressLine1
        addressArea
        addressCity
        addressDistrict
      }
      containertype {
        id
        name
      }
    }
  }
`;

// Add new QR code
export const gqlAdd = gql`
  mutation addContainerQrcode($data: ContainerQrcodeInput) {
    addContainerQrcode(data: $data) {
      id
      qrCode
      collectionPointId
      binSerialNo
      containerTypeId
      latitude
      longitude
      comments
      isActive
    }
  }
`;

// Update existing QR code
export const gqlUpdate = gql`
  mutation updateContainerQrcode($data: ContainerQrcodeInput) {
    updateContainerQrcode(data: $data) {
      id
      qrCode
      collectionPointId
      binSerialNo
      containerTypeId
      latitude
      longitude
      comments
      isActive
    }
  }
`;

// Delete QR code
export const gqlDelete = gql`
  mutation deleteContainerQrcode($id: Int!) {
    deleteContainerQrcode(id: $id)
  }
`;
